(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rv-mobile-ux"] && !Shopify.designMode) return;
  try {
    const riftValleyFirstLoadStartedAt = Date.now();
  let riftValleyEngagementReady = false;

  const riftValleyCondenseCookieCopy = () => {
    const config = document.querySelector('.rv-mobile-ux');
    const paragraph = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    const policyLink = paragraph?.querySelector('#shopify-pc__banner__body-policy-link');
    const condensedText = config?.dataset.rvCookieText?.trim();

    if (!paragraph || !policyLink || !condensedText || paragraph.dataset.rvCondensed === 'true') return;

    paragraph.replaceChildren(document.createTextNode(`${condensedText} `), policyLink);
    paragraph.dataset.rvCondensed = 'true';
  };

  const riftValleyElementVisible = (element) => {
    if (!element || element.getClientRects().length === 0) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const riftValleyScrollDepthReached = () => {
    const scrollableDistance = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableDistance <= 0) return false;
    return window.scrollY / scrollableDistance >= 0.3;
  };

  const riftValleyFormsOverlayVisible = (host) => {
    if (!host || host.dataset.rvDeferred === 'true' || !host.shadowRoot) return false;
    const overlay = host.shadowRoot.querySelector('[data-layout="overlay"]');
    return riftValleyElementVisible(overlay);
  };

  const riftValleyOverlayState = () => {
    const body = document.body;
    if (!body) return;

    riftValleyCondenseCookieCopy();

    const rewardLabels = [...document.querySelectorAll('button, a, div, span')].filter((element) => {
      const text = element.textContent.trim();
      return /^(prämien|praemien|rewards?)$/i.test(text);
    });

    rewardLabels.forEach((element) => {
      let current = element;
      while (current && current !== body) {
        if (getComputedStyle(current).position === 'fixed') {
          current.dataset.rvFloatingRewards = 'true';
          break;
        }
        current = current.parentElement;
      }
    });

    if (!riftValleyEngagementReady) {
      const delayReached = Date.now() - riftValleyFirstLoadStartedAt >= 10000;
      riftValleyEngagementReady = delayReached || riftValleyScrollDepthReached();
    }

    const menuOpen = riftValleyElementVisible(document.querySelector('.main-menu__disclosure.is-open'));
    const drawerOpen = riftValleyElementVisible(document.querySelector('cart-drawer[open], quick-add-drawer[open], .drawer[open]'));
    const cookieOpen = riftValleyElementVisible(document.querySelector('#shopify-pc__banner'));
    const modalOpen = [...document.querySelectorAll('[role="dialog"]')].some((element) => {
      return riftValleyElementVisible(element) && element.getAttribute('aria-hidden') !== 'true';
    });
    const formsHosts = [...document.querySelectorAll('shopify-forms-embed')];
    const deferForms = cookieOpen || !riftValleyEngagementReady;
    const deferFormsValue = String(deferForms);

    formsHosts.forEach((host) => {
      if (host.dataset.rvDeferred !== deferFormsValue) host.dataset.rvDeferred = deferFormsValue;
      if (host.getAttribute('aria-hidden') !== deferFormsValue) host.setAttribute('aria-hidden', deferFormsValue);
    });

    const formsOpen = formsHosts.some(riftValleyFormsOverlayVisible);

    body.dataset.rvCookieOpen = String(cookieOpen);
    body.dataset.rvOverlayActive = String(menuOpen || drawerOpen || cookieOpen || modalOpen || formsOpen);
  };

  riftValleyOverlayState();
  document.addEventListener('click', () => requestAnimationFrame(riftValleyOverlayState));
  document.addEventListener('transitionend', riftValleyOverlayState);
  window.addEventListener('scroll', riftValleyOverlayState, { passive: true });
  window.setTimeout(riftValleyOverlayState, 10000);

  const riftValleyObserver = new MutationObserver(riftValleyOverlayState);
  riftValleyObserver.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'open', 'aria-hidden', 'style']
  });
  } catch(e) { console.error(e); }
})();

})();
